<template>
  <div class="modal" v-if="seen">
    <div class="permanent">
      <span>Moving <strong>files</strong> to trash</span>
      <br />
      <span><img src="@/assets/30.gif" /></span>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      seen: false,
      loader: false,
      error: false,
      id: null,
      found: false
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE',
      'EMPTY_FILE_ACTION',
      'SET_SELECT_ALL',
      'EMPTY_FILES_INDEX',
      'SET_FILE_ACTION'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    load() {
      this.seen = true

      let that = this

      let data = {
        token: cookies.getCookie('token'),
        files: this.$store.getters.GET_FILE_ACTION,
        delete_type: false
      };

      this.$socket.emit('group-delete', data, function (data) {
        if (data.message === 'completed') {
          that.seen = false

          // for(let i = 0; i < that.$store.getters.GET_FILE_ACTION.length; i++) {
          //     let index = that.$store.getters.GET_FILES_INDEX[that.$store.getters.GET_FILE_ACTION[i]]
          //     that.$store.getters.DIRECTORY_CHILDREN.splice(index, 1)

          //     //let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - that.$store.getters.DIRECTORY_CHILDREN[index].size
          //     //that.UPDATE_TOTAL_USED_SPACE(total_space_used)
          // }

          let indexes = Object.values(that.$store.getters.GET_FILES_INDEX)

          for (let i = 0; i < indexes.length; i++) {
            if (i == 0) {
              that.$store.getters.DIRECTORY_CHILDREN.splice(indexes[i], 1)
            } else {
              if (indexes[i] == 0) {
                that.$store.getters.DIRECTORY_CHILDREN.splice(indexes[i], 1)
              }

              that.$store.getters.DIRECTORY_CHILDREN.splice(indexes[i] - 1, 1)
            }
          }

          that.$store.getters.DIRECTORY_CHILDREN.map(file => {
            file.is_checked = false
          })

          that.$forceUpdate()

          that.EMPTY_FILES_INDEX()
          that.SET_FILE_ACTION('')
          that.SET_SELECT_ALL(false)
          that.seen = false
          that.names = []
          that.loader = false
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
